module.exports = __webpack_public_path__ + "auth_bg.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/auth_bg.png
// module id = 2180
// module chunks = 13